import "./AssignLabToTestComponent.scss";
import FormTitleWithNavigationBack
    from "../../../../shared/components/form-title-with-navigation-back/FormTitleWithNavigationBack";
import React, {useCallback, useEffect, useState} from "react";
import SearchComponent from "../../../../shared/components/search/SearchComponent";
import TabsWrapperComponent, {
    TabComponent,
    TabContentComponent,
    TabsComponent
} from "../../../../shared/components/tabs/tabsComponent";
import CheckBoxComponent from "../../../../shared/components/core/checkbox/CheckboxComponent";
import commonService from "../../../../shared/services/common.service";
import ButtonComponent from "../../../../shared/components/core/button/ButtonComponent";
import {CommonService} from "../../../../shared/services";
import {IAPIResponseType} from "../../../../shared/models/api.model";
import DrawerComponent from "../../../../shared/components/drawer/drawerComponent";
import DrawerDetailsDataKeyValueComponent
    from "../../../../shared/components/drawer-details-data-key-value/DrawerDetailsDataKeyValueComponent";

interface AssignLabToTestComponentProps {
    testID: any;
    cancel: Function;
    next: Function;
    prev: Function;
}

const AssignLabToTestComponent = (props: AssignLabToTestComponentProps) => {
    const {testID, cancel, next, prev} = props;

    const [selectedLabIds, setSelectedLabIds] = React.useState<any>([]);
    const [labDetails, setLabDetails] = useState<any>(undefined);
    const [isLabDetailsLoading, setIsLabDetailsLoading] = useState<boolean>(false);
    const [isLabDetailsDrawerOpen, setIsLabDetailsDrawerOpen] = useState<boolean>(false);
    const [isLabListLoading, setIsLabListLoading] = useState<boolean>(false);
    const [labsList, setLabsList] = useState<any>([]);
    const [searchText, setSearchText] = useState<string>('');
    const [isLabsIsGettingAssigned, setIsLabsIsGettingAssigned] = useState<boolean>(false);
    const handleSearch = (value: any) => {
        console.log('handleSearch', value);
        setSearchText(value);
    }

    const getLabDetails = useCallback((labID: string) => {
        const payload = {};
        setIsLabDetailsLoading(true);
        CommonService._lab.getLabDetails(labID, payload)
            .then((response: IAPIResponseType<any>) => {
                setLabDetails(response?.data);
                setIsLabDetailsLoading(false);
            })
            .catch((error: any) => {
                setIsLabDetailsLoading(false);
            });
    }, []);

    const getLabListLite = useCallback((searchText: string) => {
        const payload = {
            search: searchText
        };
        setIsLabListLoading(true);
        CommonService._lab.getLabListLite(payload)
            .then((response: IAPIResponseType<any>) => {
                setLabsList(response?.data);
                setIsLabListLoading(false);
            })
            .catch((error: any) => {
                setIsLabListLoading(false);
                setLabsList([]);
            });
    }, []);

    useEffect(() => {
        getLabListLite(searchText);
    }, [searchText,getLabListLite]);

    const handleViewLabDetails = useCallback((labId: any) => {
        setLabDetails(undefined);
        getLabDetails(labId);
        setIsLabDetailsDrawerOpen(true);
    }, [getLabDetails]);

    const handleAssignLab = useCallback(() => {
        const payload = {
            testId: testID,
            labIds: selectedLabIds
        }
        if (selectedLabIds.length === 0) {
            next();
        } else {
            setIsLabsIsGettingAssigned(true);
            commonService._test.assignLabsToTest(payload)
                .then((response: IAPIResponseType<any>) => {
                    setIsLabsIsGettingAssigned(false);
                    next();
                })
                .catch((error: any) => {
                    setIsLabsIsGettingAssigned(false);
                });
        }
    }, [selectedLabIds,testID,next]);

    return (
        <div className={'assign-lab-to-test-component  screen t-form-screen'}>
            <FormTitleWithNavigationBack
                title={'Assign Lab'}
                tooltipData={"Assign Lab"}
                handleClick={prev}
            />
            <div className="t-form attachments-with-title-wrapper">
                {/* eslint-disable-next-line no-script-url */}
                <form noValidate={true} action={'javascript:void'}>
                    <div className="t-form-controls-wrapper">
                        <SearchComponent
                            label={"Search Lab"}
                            id="search_input"
                            placeholder={"Search by Lab name"}
                            value={searchText}
                            onChange={handleSearch}
                        />
                        <TabsWrapperComponent>
                            <TabsComponent
                                allowScrollButtonsMobile={false}
                                variant={"fullWidth"}
                            >
                                <TabComponent label="LABS" value={'labs'}/>
                            </TabsComponent>
                            <TabContentComponent
                                selectedTab={"labs"} value={"labs"}
                            >
                                {
                                    isLabListLoading ?
                                        <div className={'lab-list-loading'}>

                                        </div> :
                                        labsList?.length > 0 ?
                                            <div>
                                                {
                                                    labsList?.map((lab: any, index: number) => {
                                                        return (
                                                            <div key={index} className={'lab-list-item'}>
                                                                <div className={'lab-list-item-name-and-selection'}>
                                                                    <CheckBoxComponent
                                                                        checked={selectedLabIds.includes(lab.id)}
                                                                        onUpdate={(isChecked: boolean) => {
                                                                            if (isChecked) {
                                                                                setSelectedLabIds([...selectedLabIds, lab.id]);
                                                                            } else {
                                                                                setSelectedLabIds(selectedLabIds.filter((id: any) => id !== lab.id));
                                                                            }
                                                                        }}
                                                                        name={commonService.capitalizeFirstLetterOfEachWord(lab.name)}
                                                                    />
                                                                    <div className={'lab-list-item-name'}>
                                                                        {commonService.capitalizeFirstLetterOfEachWord(lab.name)}
                                                                    </div>
                                                                </div>
                                                                <div className={'lab-list-item__action'}>
                                                                    <div className={'underline-button'} onClick={() => {
                                                                        handleViewLabDetails(lab.id);
                                                                    }}>
                                                                        View Details
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )
                                                    })
                                                }
                                            </div> :
                                            <div>
                                                No Labs Found
                                            </div>
                                }
                            </TabContentComponent>
                        </TabsWrapperComponent>
                    </div>
                    <div className='form-action-section'>
                        <ButtonComponent
                            type="button"
                            color={"primary"}
                            variant={"outlined"}
                            disabled={isLabsIsGettingAssigned}
                            fullWidth={true}
                            handleClick={cancel}
                        >
                            Close
                        </ButtonComponent>
                        <ButtonComponent
                            type="button"
                            color={"primary"}
                            variant={"contained"}
                            fullWidth={true}
                            isLoading={isLabsIsGettingAssigned}
                            handleClick={handleAssignLab}
                        >
                            {selectedLabIds.length > 0 ? 'Next' : 'Skip'}
                        </ButtonComponent>
                    </div>
                </form>
            </div>
            <DrawerComponent
                title={'Lab Details'}
                open={isLabDetailsDrawerOpen}
                onClose={() => {
                    setIsLabDetailsDrawerOpen(false);
                }}
            >
                <div className={'view-details-drawer'}>
                    {
                        isLabDetailsLoading ?
                            <div className={'lab-details-drawer__loading'}>
                                Loading...
                            </div> :
                            <div>
                                {
                                    labDetails ?
                                        <div>
                                            <DrawerDetailsDataKeyValueComponent title={'Lab Name:'}>
                                                {labDetails?.name ? commonService.capitalizeFirstLetterOfEachWord(labDetails?.name) : 'N/A'}
                                            </DrawerDetailsDataKeyValueComponent>
                                            <DrawerDetailsDataKeyValueComponent title={'Lab ID:'}>
                                                {labDetails?.id || 'N/A'}
                                            </DrawerDetailsDataKeyValueComponent>
                                            <DrawerDetailsDataKeyValueComponent
                                                title={"CAP ID:"}> {labDetails?.capId || 'N/A'} </DrawerDetailsDataKeyValueComponent>
                                            <DrawerDetailsDataKeyValueComponent
                                                title={"Lab Type:"}> {CommonService.mapLabTypeToName(labDetails?.labType) || 'N/A'}
                                            </DrawerDetailsDataKeyValueComponent>
                                            <div className={'horizontal-line'}></div>
                                            <DrawerDetailsDataKeyValueComponent
                                                title={"Email ID:"}> {labDetails?.emailId || 'N/A'} </DrawerDetailsDataKeyValueComponent>
                                            <DrawerDetailsDataKeyValueComponent
                                                title={"Mobile Number:"}> {CommonService.getMaskedMobileNumber(labDetails?.mobileNumber) || 'N/A'} </DrawerDetailsDataKeyValueComponent>
                                            <div className={'horizontal-line'}></div>
                                            <DrawerDetailsDataKeyValueComponent
                                                title={"Address Line 1:"}> {labDetails?.addressLine1 || 'N/A'} </DrawerDetailsDataKeyValueComponent>
                                            <DrawerDetailsDataKeyValueComponent
                                                title={"Address Line 2:"}> {labDetails?.addressLine2 || 'N/A'} </DrawerDetailsDataKeyValueComponent>
                                            <DrawerDetailsDataKeyValueComponent
                                                title={"ZIP Code:"}> {labDetails?.zipcode || 'N/A'} </DrawerDetailsDataKeyValueComponent>
                                            <DrawerDetailsDataKeyValueComponent
                                                title={"State:"}> {labDetails?.state || 'N/A'} </DrawerDetailsDataKeyValueComponent>
                                            <DrawerDetailsDataKeyValueComponent
                                                title={"City:"}> {labDetails?.city || 'N/A'} </DrawerDetailsDataKeyValueComponent>
                                        </div> :
                                        <div>
                                            No Details Found
                                        </div>
                                }
                            </div>
                    }
                </div>
            </DrawerComponent>
        </div>
    );

};

export default AssignLabToTestComponent;